<template>
  <div>
    <!-- App menu - Mobile Side menu-->
    <v-overlay v-if="!isMdAndUpDevice" v-model="sidebar" z-index="11" color="white" opacity="1" class="HLAppBar">
      <v-list nav color="rgba(0, 0, 0, 0)">
        <v-list-item
          v-for="(item,index) in menu"
          :key="'btnMenuText-'+index"
          :href="item.link"
          target="_blank"
          link
          rel="preload"
          @click="onClickMenuIcon(false)"
          :ripple="false"
          :class="item.classes"
          v-show="(item.auth && isLoggedIn) || (!item.auth && !isLoggedIn) || item.auth==undefined"
          class="text-transform-none text-center menuItemText black--text title"
          light
        >
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-overlay>
    
    <!-- App bar -->
    <!-- Mobile -->
    <v-app-bar ref="appBar" v-if="!isMdAndUpDevice" :style="{'z-index':(sidebar)?'9999999':'99999'}" :color="'white'" height="70" flat :hide-on-scroll="!sidebar" class="HLAppBar" scroll-threshold="100" app>
      <v-toolbar-title>
       <a v-if="!sidebar" href="https://www.globalsocial-network.org/" target="_blank" class="no-underline"><img class="mt-2" src="/img/logo_GlobalSocial.jpeg" height="55px"/></a>
       <a v-if="!sidebar" href="https://sofareisen.org" target="_blank" class="no-underline"><img class="ml-2 mt-2" src="/img/logo_sofareisen.png" height="55px"/></a>
      </v-toolbar-title>
      <v-spacer/>

      <!-- Language selector -->
      <LanguageSelector v-if="!sidebar"/>

      <!-- close Icon -->
      <v-app-bar-nav-icon x-large :ripple="false" @click="onClickMenuIcon">
        <v-icon>{{sidebar?'mdi-close':'mdi-menu'}}</v-icon>
      </v-app-bar-nav-icon>

    </v-app-bar>

    <!-- Desktop -->
    <v-app-bar ref="appBar" v-else @click="onClickMenuIcon(false)" height="70" class="m-auto HLAppBar" style="z-index:9999" flat :hide-on-scroll="false" color="white" scroll-threshold="100" app>
        <v-toolbar flat max-width="80%" class="m-auto">
        <v-toolbar-title>
          <a href="https://www.globalsocial-network.org/" target="_blank" class="no-underline"><img class="mt-2" src="/img/logo_GlobalSocial.jpeg" height="55px"/></a>
          <a href="https://www.sofareisen.org" target="_blank" class="no-underline"><img class="ml-2 mt-2" src="/img/logo_sofareisen.png" height="55px"/></a>
        </v-toolbar-title>
        <v-spacer/>
        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn
            v-for="(item,index) in menu"
            :key="'btnText-'+index"
            :href="item.link"
            target="_blank"
            rel="preload"
            :ripple="false"
            :class="item.classes"
            v-show="(item.auth && isLoggedIn) || (!item.auth && !isLoggedIn) || item.auth==undefined"
            text
            class="text-transform-none menuItem px-5"
          >{{ item.title }}</v-btn>
        <!-- User Area -->

        </v-toolbar-items>
        </v-toolbar>

        <!-- Language selector -->
        <LanguageSelector/>

      
      <!--{{ $t('app-title') }}-->
    </v-app-bar>
  </div>
</template>

<script>
import {settingsMixin} from '@/utils/settings-mixin'
import {layoutMixin} from '@/utils/layout-mixin'
import {appbarScrollingDirective} from '@/directive/appbar-scrolling-directive'
import LanguageSelector from "@/components/ui/LanguageSelector"
//import trans from '@/locale/trans'

export default {
  mixins: [settingsMixin,layoutMixin,appbarScrollingDirective],
  components:{
    LanguageSelector
  },
  computed: {
      menuAdmin(){
          return [
        ]
      },
      menuDropdown() {
          return (this.isAdmin)?this.menuAdmin:[
        ]
      },
      menu(){ return [
        { title: this.$t('menu_donation'), link:'https://www.globalsocial-network.org/jetzt-spenden/',classes:'font-weight-bold' },
        { title: this.$t('menu_aboutus'), link:'https://www.globalsocial-network.org/ueber-uns/' },
        { title: this.$t('menu_contact'),link:'https://www.globalsocial-network.org/kontakt/' }
      ]},
  },
  data () {
    return {
      sidebar: false,
      dropDownMenu:false,
      menuImg: [
        { title: 'Login',icon:'/img/logos/person_circle.png', link:'/login', auth:true},//mdi-account-circle-outline
      ]
    }
  },
  methods:{
    onClickMenuIcon(forceValue){
      this.sidebar=(this._.isBoolean(forceValue))?forceValue:!this.sidebar;
      this.makeBodyUnscrollable(this.sidebar);
    }
  }
}
</script>

<style scoped>
.HlLoginLinkFont{
  color:#763299!important;
}

</style>

